import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  dictionariesFederalLawsGet,
  dictionariesKnoOrganizationsItemGet,
  dictionariesProfKindsItemGet,
  dictionariesSupervisionTypesItemGet,
} from 'CorePackage/DictionariesModule/actions/dictionariesActions';
import { catalogPmConditionsGet } from 'CorePackage/CatalogsModule/actions/catalogsActions';
import { accountOrganizationsWithDistrictGet } from 'CorePackage/AccountModule/actions/accountActions';

export const useCreatePreventionModalOptionsFetch = (
  knoOrgId?: string,
  federalLawId?: string,
  supervisionId?: string,
  profKindId?: string,
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(dictionariesKnoOrganizationsItemGet());
    dispatch(dictionariesFederalLawsGet());
    dispatch(accountOrganizationsWithDistrictGet());
  }, [dispatch]);

  useEffect(() => {
    if (knoOrgId && federalLawId) {
      dispatch(dictionariesSupervisionTypesItemGet([knoOrgId], false, federalLawId ? [federalLawId] : undefined));
    }
  }, [dispatch, knoOrgId, federalLawId]);

  useEffect(() => {
    if (knoOrgId && supervisionId) {
      dispatch(
        dictionariesProfKindsItemGet({
          knoVersionId: knoOrgId,
          supervisionVersionId: supervisionId,
        }),
      );
    }
  }, [dispatch, knoOrgId, supervisionId]);

  useEffect(() => {
    if (knoOrgId && supervisionId && profKindId) {
      dispatch(catalogPmConditionsGet(knoOrgId, supervisionId, profKindId, federalLawId));
    }
  }, [dispatch, knoOrgId, supervisionId, profKindId]);
};
